import './graph-title-sk';
